import state from "./state";
import { useSnapshot } from "valtio";

export default function WeatherTemp(props) {
  const snape = useSnapshot(state);

  if (snape.unit === "celsius") {
    return (
      <div className="WeatherTemp">
        <span className="Temperature">{Math.round(props.temperature)}</span>
        <span className="Units position-relative">ºC</span>
      </div>
    );
  } else {
    let fahrenheit = (props.temperature * 9) / 5 + 32;
    return (
      <div className="WeatherTemp">
        <span className="Temperature">{Math.round(fahrenheit)}</span>
        <span className="Units position-relative">ºF</span>
      </div>
    );
  }
}
